import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../index.module.css'

/**
 * FAQ Card component displaying a single FAQ item with title, description, and link
 */
const FAQCard = ({ title, description, url }) => {
  const handleCardClick = () => {
    window.open(url, '_blank')
  }

  return (
    <div className={styles.faqCard} onClick={handleCardClick}>
      <h3 className={styles.faqCardTitle}>{title}</h3>
      <p className={styles.faqCardDescription}>{description}</p>
      <a href={url} className={styles.faqCardLink} target="_blank" rel="noopener noreferrer">
        Learn More
      </a>
    </div>
  )
}

FAQCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}

export default FAQCard